import { format } from 'date-fns';
import { EmailJob } from '@/types/emails';

// Date formatting utility
export const formatEmailDate = (dateString: string): string => format(new Date(dateString), 'MMM dd, HH:mm');

// Search utility for emails
export const filterEmails = <T extends { recipient_email?: string; subject?: string; generated_subject?: string; user_business_name?: string }>(
  emails: T[],
  searchTerm: string
): T[] => {
  if (!searchTerm) return emails;

  const searchLower = searchTerm.toLowerCase();
  return emails.filter(email =>
    email.recipient_email?.toLowerCase().includes(searchLower) ||
    email.subject?.toLowerCase().includes(searchLower) ||
    email.generated_subject?.toLowerCase().includes(searchLower) ||
    email.user_business_name?.toLowerCase().includes(searchLower)
  );
};

// Generate HTML from text utility
export const generateHtmlFromText = (textBody: string): string => {
  const paragraphs = textBody.split('\n\n');
  const htmlParagraphs = paragraphs.map(p => {
    const trimmed = p.trim();
    if (!trimmed) return '';
    const escaped = trimmed.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const withBreaks = escaped.replace(/\n/g, '<br>');
    return `<p style="margin: 0 0 10px 0;">${withBreaks}</p>`;
  }).filter(p => p);

  return htmlParagraphs.join('\n');
};


export function formatPostmarkError(errorMessage: string): string {
  if (!errorMessage) {
    return errorMessage;
  }

  const message = errorMessage.toLowerCase();
  if (message.includes('invalid email address') || message.includes('invalid email address format')) return 'Invalid email address - please check the email format and try again';
  if (message.includes('inactive recipient')) return 'Email address is inactive - please contact the recipient to verify their email is active';
  if (message.includes('postmark authentication failed') || message.includes('authentication failed')) return 'Email service configuration error - please contact support';
  if (message.includes('rate limit exceeded')) return 'System: Too many emails sent at once';
  if (message.includes('postmark api error: 406') || message.includes('postmark api error: 422')) return 'Invalid email address format - please check the email and try again';
  if (message.includes('postmark api error: 300')) return 'Email address is inactive - please contact the recipient';
  if (message.includes('postmark api error: 401')) return 'System: Email service authentication failed';
  if (message.includes('postmark api error: 429')) return 'System: Email sending rate limit exceeded';

  return errorMessage;
} 

export function getDisplayStatus(job: EmailJob): string {
  if (job.status === 'sending') return 'sending';
  if (job.status === 'completed') return 'completed';
  if (job.status === 'failed' || job.status === 'failed_inactive_recipient') return job.status;
  if (job.status === 'cancelled') return 'cancelled';
  
  if (job.status === 'awaiting_preview') {
    if (job.preview_status === 'approved') return 'sending'; 
    if (job.preview_status === 'cancelled') return 'cancelled';
    return 'awaiting_preview'; 
  }
  
  return job.status;
}